// Copyright (c) 2015, Daffy Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if(!window.daffy)
	window.daffy = {};

daffy.provide = function(namespace) {
	// docs: create a namespace //
	var nsl = namespace.split('.');
	var parent = window;
	for(var i=0; i<nsl.length; i++) {
		var n = nsl[i];
		if(!parent[n]) {
			parent[n] = {}
		}
		parent = parent[n];
	}
	return parent;
}

daffy.provide("locals");
daffy.provide("daffy.flags");
daffy.provide("daffy.settings");
daffy.provide("daffy.utils");
daffy.provide("daffy.ui.form");
daffy.provide("daffy.modules");
daffy.provide("daffy.templates");
daffy.provide("daffy.test_data");
daffy.provide('daffy.utils');
daffy.provide('daffy.model');
daffy.provide('daffy.user');
daffy.provide('daffy.session');
daffy.provide('locals.DocType');

// for listviews
daffy.provide("daffy.listview_settings");
daffy.provide("daffy.listview_parent_route");

// constants
window.NEWLINE = '\n';
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm=null;
